module.exports = __webpack_public_path__ + "media/images/front/brands/creations/creations_header_2-62457c1ed6cc90c4447df650f6f573b2.jpg";